/**
 * @deprecated - This component is no longer in use.
 *
 * @file product-details.tsx
 * @module all-products/product-details
 * @description The ProductDetails component allows users to view and manage product details.
 *
 * @author Rocket Technologies Ltd
 * @copyright 2026. Rocket Technologies Ltd. All rights reserved.
 * @since 1.1.1
 * @version 2.1.2
 */

import {
  Button,
  Card,
  Col,
  OverlayTrigger,
  Popover,
  Row,
  Tooltip,
} from "react-bootstrap";
import React, { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import RejectProduct from "../../modals/reject-product";
import RoundThreeDot from "../../../_admin/assets/media/svg_uTrade/three-dot-round.svg";
import TabPriceDimensions from "../products/product-details-tabs/price-dimensions";
import TabProductDetails from "../products/product-details-tabs/product-details";
import TabInventoryHistory from "../products/product-details-tabs/product-inventory-history";
import TabStockDetails from "../products/product-details-tabs/product-stock-details";
import APICallService from "../../../api/apiCallService";
import {
  inventory,
  manageProduct,
  ordersDelivery,
  product,
  reports,
} from "../../../api/apiEndPoints";
import Loader from "../../../Global/loader";
import {
  Accepted,
  All,
  AllSeller,
  ApprovedProduct,
  CartonWithDozens,
  CartonWithPieces,
  Dozen,
  Edit,
  FinanceManager,
  FulfillmentManager,
  LoadingBayManager,
  NewRequests,
  PendingProduct,
  Piece,
  Rejected,
  RejectedProduct,
  UnderReview,
  View,
  All_Products,
  Admin,
  AssistAdmin,
  PermissionModule,
  Permissions,
} from "../../../utils/constants";
import { CustomSelectTable } from "../../custom/Select/CustomSelectTable";
import { error, success } from "../../../Global/toast";
import ReturnGoodsSellerModal from "../../modals/return-goods-seller-modal";
import { useAuth } from "../auth";
import ProductInventorySVG from "../../../_admin/assets/media/dashboard/product-inventory.svg";
import { reportJson } from "../../../api/apiJSON/reports";
import { getKey, setKey } from "../../../Global/history";
import { listProductDetails } from "../../../utils/storeString";
import Method from "../../../utils/methods";
import PermissionModal from "../../modals/permission";
import { useWarehouse } from "../../context/WarehouseContext";
import { productJSON } from "../../../api/apiJSON/product";
import { getQuantityTypeLabel } from "../../../utils";
import ImageWithFallback from "../_common/components/image-with-fallback";
const ProductDetails = () => {
  const { currentUser } = useAuth();
  const { state }: any = useLocation();
  const navigate = useNavigate();
  const { selectedWarehouse } = useWarehouse();
  const [fetchLoader, setFetchLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [downloadLoading, setDownloadLoading] = useState(false);
  const [rejectLoading, setRejectLoading] = useState(false);
  const [productDetails, setProductDetails] = useState<any>();
  const [businessDetails, setBusinessDetails] = useState<any>();
  const [isPharmacyProduct, setIsPharmacyProduct] = useState(false);
  const [disabledFields, setDisabledFields] = useState("");
  const [message, setMessage] = useState("");
  const [validation, setValidation] = useState(false);
  const [expired, setExpired] = useState<any>();
  const [expiring, setExpiring] = useState<any>();
  const [productList, setProductList] = useState<any>([]);
  const [modalLoader, setModalLoader] = useState(false);
  const [returnGoodsSeller, setReturnGoodsSeller] = useState(false);
  const [show, setShow] = useState(false);
  const [ids, setIds] = useState<any>([]);
  const [count, setCount] = useState(0);
  const handleSelectTab = (tab: any) => {
    setCurrentTab(tab);
    setKey(listProductDetails.currentTab, tab, false);
  };
  const [showPermissionModal, setShowPermissionModal] = useState(false);

  useEffect(() => {
    let stored = sessionStorage.getItem("pendingIds");

    if (stored) {
      // Case 1 → refresh OR already processed → always use stored
      const parsed = JSON.parse(stored);
      setIds(parsed);
    } else {
      // Case 2 → first time navigation
      if (state?.status === PendingProduct) {
        setIds(state.ids);
        sessionStorage.setItem("pendingIds", JSON.stringify(state.ids));
      } else {
        setIds([state.id]);
        sessionStorage.setItem("pendingIds", JSON.stringify([state.id]));
      }
    }
    return () => {
      sessionStorage.removeItem("pendingIds");
    };
  }, []);
  useEffect(() => {
    (async () => {
      if (!ids.length) return;

      setFetchLoader(true);
      await fetchProductDetails(ids[0], selectedWarehouse?.value || null);
      setFetchLoader(false);
    })();
  }, [ids, selectedWarehouse?.value]);

  const fetchLastMonthOrder = async (
    businessID?: String,
    productId?: String,
    warehouseId?: any,
  ) => {
    let params: any = { variant: productId };
    if (warehouseId) {
      params = { ...params, warehouse: warehouseId };
    }
    let apiService = new APICallService(
      businessID
        ? ordersDelivery.variant
        : ordersDelivery.variantWithoutBusinessId,
      params,
      { _id: businessID },
      "",
      "",
      "",
      All_Products,
      warehouseId || null,
    );
    let response = await apiService.callAPI();
    setCount(response?.count);
  };
  const fetchProductDetails = async (productId: String, warehouseId?: any) => {
    let apiService = new APICallService(
      product.productInfo,
      productId,
      "",
      "",
      "",
      "",
      All_Products,
      warehouseId || null,
    );
    let response = await apiService.callAPI();
    // Request failed (error already shown by the API service): keep the page instead of crashing
    if (!response?.record) return;
    setProductDetails(response?.record);
    setIsPharmacyProduct(response?.record?.isPharmacyProduct ?? false);
    setBusinessDetails(response.business);
    let tempFields = response.record.technicalInfo
      .filter((a: any) => a.enabled == false)
      .map((a: any) => a.name)
      .join(", ");
    setDisabledFields(tempFields);
    setTab([
      { name: "Product details" },
      { name: "Price & dimensions" },
      { name: "History of inventory" },
      { name: "Stock Details" },
    ]);

    fetchLastMonthOrder(
      response.business?.businessProfile?._id,
      productId,
      warehouseId,
    );
  };
  const [tab, setTab] = useState([
    { name: "Product details" },
    { name: "Price & dimensions" },
  ]);

  const [currentTab, setCurrentTab] = useState<any>(() => {
    const storedTabData = getKey(listProductDetails.currentTab);
    return storedTabData || { name: "Product details" };
  });
  const createTabs = () => {
    const localTab = tab;
    let current = currentTab;
    const allTabs = localTab.map((tab) => {
      return (
        <li className="nav-item">
          <Link
            to={"/"}
            className={
              current.name === tab.name
                ? "nav-link active text-active-primary"
                : "nav-link text-hover-primary"
            }
            data-bs-toggle="tab"
            data-analytics-event="all_products_details_tab_clicked"
            onClick={() => handleSelectTab(tab)}
          >
            {tab.name}
          </Link>
        </li>
      );
    });
    return allTabs;
  };
  const handleProductApprove = async (status: number) => {
    setLoading(true);

    const currentId = ids[0];
    let productDetailsTemp = { ...productDetails };
    let apiService = new APICallService(
      manageProduct.updateVariantStatus,
      { status },
      { id: currentId },
      "",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );

    let response = await apiService.callAPI();

    if (response) {
      // remove current id
      let updated = ids.filter((x: any) => x !== currentId);

      setIds(updated);
      sessionStorage.setItem("pendingIds", JSON.stringify(updated));

      if (!updated.length && state.moduleName === 34) {
        navigate("/all-products");
      } else {
        productDetailsTemp.status = status;
        setProductDetails(productDetailsTemp);
      }

    }
    setLoading(false);
  };

  const handleProductReject = async (status: number) => {
    if (message.length === 0) {
      setValidation(true);
      return;
    }

    setRejectLoading(true);
    let productDetailsTemp = { ...productDetails };
    const currentId = ids[0];

    let apiService = new APICallService(
      manageProduct.updateVariantStatus,
      {
        status,
        message,
      },
      { id: currentId },
      "",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );

    const response = await apiService.callAPI();

    if (response) {
      // Remove the processed ID (do NOT repeat rejected items)
      let updated = ids.filter((x: any) => x !== currentId);

      setIds(updated);
      sessionStorage.setItem("pendingIds", JSON.stringify(updated));

      if (!updated.length && state.moduleName === 34) {
        navigate("/all-products");
      } else {
        productDetailsTemp.status = status;
        productDetailsTemp.statusMessage = message;
        setProductDetails(productDetailsTemp);
      }
    }

    setShowRejectProduct(false);

    setValidation(false);
    setRejectLoading(false);
  };

  const handleChange = (value: string) => {
    if (value.length > 0) {
      setValidation(false);
    } else {
      setValidation(true);
    }
    setMessage(value);
  };
  const [showRejectProduct, setShowRejectProduct] = useState(false);
  const renderTooltip = (props: any) => (
    <Tooltip className="tooltip w-lg-275px" {...props}>
      <p className="text-white mb-0 fs-14 fw-500">
        Once seller account is approved then you'll be able to access these
        features.
      </p>
    </Tooltip>
  );
  const renderTabContent = () => {
    const storedTabData: any = getKey(listProductDetails.currentTab);
    const tabName = storedTabData?.name || tab[0]?.name;

    switch (tabName) {
      case "Product details":
        return <TabProductDetails productDetails={productDetails} />;
      case "Price & dimensions":
        return <TabPriceDimensions productDetails={productDetails} isPharmacyProduct={isPharmacyProduct} />;
      case "History of inventory":
        return <TabInventoryHistory productDetails={productDetails} />;
      case "Stock Details":
        return <TabStockDetails productDetails={productDetails} />;
      default:
        return <TabProductDetails productDetails={productDetails} />;
    }
  };
  const openMenuOnClick = async () => {
    setShow(true);
  };
  const onMenuClose = async () => {
    setShow(false);
  };
  const onMenuOpen = async () => {
    setShow(true);
  };
  const handleOption = async (event: any) => {
    if (event.value === 1) {
      navigate("/products/edit-product-variant-price", {
        state: {
          _id: productDetails?._id,
          isMaster: false,
          moduleName: state.moduleName,
        },
      });
      // navigate("/products/edit-product-variant", {
      //   state: {
      //     _id: productDetails?._id,
      //     isMaster: false,
      //     moduleName: All_Products,
      //   },
      // });
    } else if (event.value === 2) {
      if (event.value === 1) {
      } else if (event.value === 2) {
        if (productDetails?.inventoryInfo[0]?.quantityTypes.length) {
          navigate("/inventory/goods-in-warehouse/edit-stock-count", {
            state: productDetails?._id,
          });
        } else {
          error("Stock details not available!");
        }
      }
    }
  };
  const handleSellerProfile = (id: string) => {
    navigate("/all-products/seller-profile", {
      state: { id: id, moduleName: All_Products },
    });
  };
  const fetchExpiringProducts = async () => {
    setModalLoader(true);
    let apiService = new APICallService(
      inventory.variantExpiredStockList,
      {
        variant: productDetails._id,
      },
      "",
      "",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (
      (Object.keys(response).length && response.expired.quantityTypes.length) ||
      response.expiring.quantityTypes.length
    ) {
      setProductList(response.businesses);
      setExpired(response.expired);
      setExpiring(response.expiring);
      setReturnGoodsSeller(true);
    } else {
      error("No Data found");
    }
    setModalLoader(false);
  };
  const handleSubmit = async () => {
    let variants: any = [];
    [state.id].map((val: any) => {
      variants.push(val);
    });
    let params: any = {
      variants: variants,
      utcOffset: new Date().getTimezoneOffset(),
    };
    if (selectedWarehouse?.value) {
      params.warehouse = selectedWarehouse.value;
    }
    setDownloadLoading(true);
    let apiService = new APICallService(
      reports.productVariantReport,
      reportJson.getProductVariantReport(params),
      undefined,
      "blob",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response) {
      const pdfBlob = new Blob([response], { type: "application/pdf" });
      const downloadLink = document.createElement("a");
      downloadLink.href = URL.createObjectURL(pdfBlob);
      downloadLink.download = "product_variant_report" + ".pdf";
      downloadLink.click();
    } else {
      error("No Data Found");
    }
    setDownloadLoading(false);
  };
  const reserveQuantity = (
    <Popover id="popover-basic" className="bg-black">
      <Popover.Body className="p-2  border-r10px text-white">
        <span>Reserved stock</span>
      </Popover.Body>
    </Popover>
  );
  const remainingQuantity = (
    <Popover id="popover-basic" className="bg-black">
      <Popover.Body className="p-2  border-r10px text-white">
        <span>Remaining stock</span>
      </Popover.Body>
    </Popover>
  );
  const totalQuantity = (
    <Popover
      id="popover-basic"
      className="
    bg-black"
    >
      <Popover.Body className="p-2  border-r10px text-white">
        <span>Total stock</span>
      </Popover.Body>
    </Popover>
  );
  const updateProductState = async (active: boolean) => {
    let productDetailsTemp = { ...productDetails };
    let apiService = new APICallService(
      product.updateProductState,
      productJSON.updateProductState({ activate: !active }),
      {
        id: state.id,
      },
      "",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response) {
      setFetchLoader(false);
    }
  };
  const handleAvailableToSellToggle = async (currentState: boolean) => {
    if (!selectedWarehouse?.value) {
      error("Please select a warehouse first");
      return;
    }
    let apiService = new APICallService(
      product.availableToSell,
      { availableToSell: !currentState },
      {
        variantId: ids[0],
        warehouseId: selectedWarehouse.value,
      },
      "",
      "",
      "",
      All_Products,
      selectedWarehouse.value,
    );
    let response = await apiService.callAPI();
    if (response) {
      const inventory = productDetails.inventoryInfo || [];
      const warehouseInvIndex = inventory.findIndex(
        (x: any) => x && x.warehouseId === selectedWarehouse.value,
      );
      if (warehouseInvIndex !== -1) {
        inventory[warehouseInvIndex].availableToSell = !currentState;
      } else {
        inventory.push({
          warehouseId: selectedWarehouse.value,
          availableToSell: !currentState,
        });
      }
      setProductDetails({ ...productDetails, inventoryInfo: inventory });
      success(response.message || "ATS status updated successfully");
    }
  };

  const handleIsPharmacyProductToggle = async (currentState: boolean) => {
    if (!ids?.length) {
      error("Variant not available");
      return;
    }

    if (!currentState) {
      const inventoryInfoList = Array.isArray(productDetails?.inventoryInfo)
        ? productDetails.inventoryInfo
        : productDetails?.inventoryInfo
          ? [productDetails.inventoryInfo]
          : [];

      const inventoryHasPharmacyPrice = inventoryInfoList.some((inventoryItem: any) =>
        Array.isArray(inventoryItem?.quantityTypes)
          ? inventoryItem.quantityTypes.some((quantityType: any) =>
            quantityType?.priceForPharmacy !== undefined &&
            quantityType?.priceForPharmacy !== null &&
            quantityType?.priceForPharmacy !== "" &&
            Number(quantityType.priceForPharmacy) > 0,
          )
          : false,
      );

      const quantityTypesList = Array.isArray(productDetails?.quantityTypes)
        ? productDetails.quantityTypes
        : [];

      const topLevelHasPharmacyPrice = quantityTypesList.some((quantityType: any) =>
        quantityType?.priceForPharmacy !== undefined &&
        quantityType?.priceForPharmacy !== null &&
        quantityType?.priceForPharmacy !== "" &&
        Number(quantityType.priceForPharmacy) > 0,
      );

      if (!inventoryHasPharmacyPrice && !topLevelHasPharmacyPrice) {
        error("Please set Pharmacy Price first");
        return;
      }
    }

    let apiService = new APICallService(
      product.isPharmacyProduct,
      productJSON.updateIsPharmacyProduct({ isPharmacyProduct: !currentState }),
      {
        variantId: ids[0],
      },
      "",
      "",
      "",
      All_Products,
      selectedWarehouse?.value || null,
    );
    let response = await apiService.callAPI();
    if (response) {
      const updatedDetails = {
        ...productDetails,
        isPharmacyProduct: !currentState,
      };
      setProductDetails(updatedDetails);
      setIsPharmacyProduct(!currentState);
      success(response.message || "Pharmacy product status updated successfully");
    }
  };
  return (
    <>
      {showPermissionModal && (
        <PermissionModal
          show={showPermissionModal}
          onHide={() => setShowPermissionModal(false)}
          moduleName={"seller"}
        />
      )}
      {productList && productList.length && returnGoodsSeller ? (
        <ReturnGoodsSellerModal
          show={returnGoodsSeller}
          onHide={() => setReturnGoodsSeller(false)}
          productList={productList}
          expired={expired}
          expiring={expiring}
        />
      ) : (
        <></>
      )}{" "}
      <div className="bg-white">
        <div className="p-5">
          <Row className="align-items-center mb-8">
            <Col xs>
              <h1 className="fs-22 fw-bolder mb-md-0 mb-5">Product details</h1>
            </Col>
            {!(
              currentUser?.userType == Admin ||
              currentUser?.userType == AssistAdmin
            ) ? (
              <>
                {!fetchLoader &&
                  productDetails &&
                  Method.hasPermission(
                    PermissionModule.All_Products,
                    Permissions.Edit,
                    currentUser,
                  ) ? (
                  <>
                    {" "}
                    <Col xs="auto">
                      <Button
                        size="lg"
                        className="uw-btn uw-btn-primary uw-btn-lg min-h-50px"
                        data-analytics-event="all_products_details_toggle_active_clicked"
                        onClick={() =>
                          updateProductState(productDetails.active[0].active)
                        }
                        disabled={downloadLoading}
                      >
                        {!downloadLoading && (
                          <span className="indicator-label">
                            {productDetails.active[0].active
                              ? "Deactive Product"
                              : "Active Product"}
                          </span>
                        )}
                        {downloadLoading && (
                          <span
                            className="indicator-progress"
                            style={{ display: "block" }}
                          >
                            Please wait...
                            <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                          </span>
                        )}
                      </Button>
                    </Col>
                  </>
                ) : (
                  <></>
                )}
              </>
            ) : (
              <></>
            )}
            <Col xs="auto" className="order-sm-last mb-md-0 mb-5">
              <>
                <Col xs="auto">
                  {!fetchLoader ? (
                    <Button
                      variant="link"
                      className="fs-16 fw-bolder text-primary btn-flush align-self-center text-nowrap"
                      data-analytics-event="all_products_details_check_expiring_stock_clicked"
                      onClick={() => fetchExpiringProducts()}
                    >
                      {!modalLoader && (
                        <span className="indicator-label fs-16 fw-bold">
                          Check expiring stock
                        </span>
                      )}
                      {modalLoader && (
                        <span
                          className="indicator-progress fs-16 fw-bold"
                          style={{ display: "block" }}
                        >
                          Please wait...
                          <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                        </span>
                      )}
                    </Button>
                  ) : (
                    <></>
                  )}
                  {currentUser?.role.some(
                    (obj: any) =>
                      obj.type === FinanceManager ||
                      obj.type === LoadingBayManager ||
                      obj.type === FulfillmentManager,
                  ) ? (
                    <></>
                  ) : (
                    <>
                      {fetchLoader ? (
                        <></>
                      ) : (
                        <>
                          {productDetails && productDetails.deleted ? (
                            <></>
                          ) : (
                            <>
                              {Method.hasPermission(
                                All_Products,
                                Edit,
                                currentUser,
                              ) ? (
                                <Button
                                  type="button"
                                  variant="white"
                                  className="uw-btn uw-btn-light uw-btn-icon uw-btn-sm btn-icon btn-sm"
                                >
                                  <CustomSelectTable
                                    marginLeft={"-56px"}
                                    width={"130px"}
                                    placeholder={
                                      <img
                                        className="img-fluid"
                                        width={47}
                                        height={47}
                                        src={RoundThreeDot}
                                        alt=""
                                      />
                                    }
                                    options={[
                                      {
                                        label: (
                                          <Button
                                            variant=""
                                            className="btn btn-link btn-flush fs-14 fw-500 text-black ms-3 p-4  "
                                            data-analytics-event="all_products_details_edit_details_clicked"
                                          >
                                            Edit details
                                          </Button>
                                        ),
                                        value: 1,
                                      },
                                      {
                                        label: (
                                          <Button
                                            variant=""
                                            className="btn btn-link btn-flush fs-14 fw-500 text-black ms-3 p-4  "
                                            data-analytics-event="all_products_details_edit_stock_count_clicked"
                                          >
                                            Edit Stock Count
                                          </Button>
                                        ),
                                        value: 2,
                                      },
                                    ].filter(Boolean)}
                                    backgroundColor="white"
                                    show={show}
                                    onMenuClose={() => {
                                      onMenuClose();
                                    }}
                                    openMenuOnClick={() => {
                                      openMenuOnClick();
                                    }}
                                    onMenuOpen={() => {
                                      onMenuOpen();
                                    }}
                                    onChange={(event: any) => {
                                      handleOption(event);
                                    }}
                                  />
                                </Button>
                              ) : (
                                <></>
                              )}
                            </>
                          )}{" "}
                        </>
                      )}
                    </>
                  )}
                </Col>
              </>
            </Col>
            {currentUser?.role.some(
              (obj: any) =>
                obj.type === FinanceManager ||
                obj.type === LoadingBayManager ||
                obj.type === FulfillmentManager,
            ) ? (
              <></>
            ) : (
              <>
                {" "}
                {!fetchLoader && businessDetails ? (
                  productDetails?.status === ApprovedProduct ||
                    productDetails?.status === RejectedProduct ? (
                    <></>
                  ) : (
                    <>
                      {currentUser?.userType == Admin &&
                        Method.hasPermission(All_Products, Edit, currentUser) ? (
                        <Col sm="auto" className="mb-md-0 mb-5">
                          {businessDetails.businessProfile.KYC?.status ===
                            NewRequests - 1 ||
                            businessDetails.businessProfile.KYC?.status ===
                            All - 1 ||
                            businessDetails.businessProfile.KYC?.status ===
                            UnderReview - 1 ||
                            businessDetails.businessProfile.KYC?.status ===
                            Rejected - 1 ? (
                            <OverlayTrigger
                              placement="bottom"
                              // delay={{ show: 250, hide: 400 }}
                              overlay={renderTooltip}
                              trigger="hover"
                            >
                              <Button
                                variant="primary"
                                className="uw-btn uw-btn-primary min-h-50px me-3"
                                data-analytics-event="all_products_details_approve_clicked"
                              >
                                {loading ? (
                                  <span
                                    className="indicator-progress fs-16 fw-bold"
                                    style={{ display: "block" }}
                                  >
                                    Please wait...
                                    <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                  </span>
                                ) : (
                                  <span className="indicator-label fs-16 fw-bold">
                                    Approve product
                                  </span>
                                )}
                              </Button>
                            </OverlayTrigger>
                          ) : (
                            <Button
                              variant="primary"
                              className="uw-btn uw-btn-primary min-h-50px me-3"
                              data-analytics-event="all_products_details_approve_clicked"
                              onClick={() => {
                                handleProductApprove(ApprovedProduct);
                              }}
                            >
                              {loading ? (
                                <span
                                  className="indicator-progress fs-16 fw-bold"
                                  style={{ display: "block" }}
                                >
                                  Please wait...
                                  <span className="spinner-border spinner-border-sm align-middle ms-2"></span>
                                </span>
                              ) : (
                                <span className="indicator-label fs-16 fw-bold">
                                  Approve product
                                </span>
                              )}
                            </Button>
                          )}
                          <Button
                            variant="light-danger"
                            onClick={() => setShowRejectProduct(true)}
                            className="uw-btn min-h-50px me-3"
                            data-analytics-event="all_products_details_reject_clicked"
                            disabled={
                              businessDetails.businessProfile.KYC?.status ===
                              NewRequests - 1 ||
                              businessDetails.businessProfile.KYC?.status ===
                              All - 1 ||
                              businessDetails.businessProfile.KYC?.status ===
                              UnderReview - 1 ||
                              businessDetails.businessProfile.KYC?.status ===
                              Rejected - 1
                            }
                          >
                            <span className="indicator-label fs-16 fw-bold">
                              Reject product
                            </span>
                          </Button>
                        </Col>
                      ) : (
                        <></>
                      )}
                    </>
                  )
                ) : (
                  <></>
                )}
              </>
            )}
          </Row>
          {currentUser?.role.some(
            (obj: any) =>
              obj.type === FinanceManager ||
              obj.type === LoadingBayManager ||
              obj.type === FulfillmentManager,
          ) ? (
            <></>
          ) : (
            <></>
          )}
          {fetchLoader ? (
            <div className="d-flex justify-content-center">
              <Loader loading={fetchLoader} />
            </div>
          ) : (
            <>
              {productDetails && Object.keys(productDetails).length ? (
                <>
                  <RejectProduct
                    show={showRejectProduct}
                    onHide={() => {
                      setShowRejectProduct(false);
                    }}
                    handleProductReject={() => {
                      handleProductReject(RejectedProduct);
                    }}
                    loading={rejectLoading}
                    productDetails={productDetails}
                    handleChange={(value: any) => {
                      handleChange(value);
                    }}
                    message={message}
                    validation={validation}
                  />
                  <Card className="border border-custom-color mb-5 mb-xl-10">
                    {productDetails?.inventoryInfo[0]?.quantityTypes.some(
                      (quantVal: any) =>
                        quantVal.forecastedDays !== null &&
                        quantVal?.forecastedDays >= 0,
                    ) ? (
                      <div className="d-flex justify-content-end">
                        <div
                          className="d-flex justify-content-center align-items-center bg-e7f1fd py-3 px-6"
                          style={{ borderRadius: "0 8px 0 10px" }}
                        >
                          <div
                            className="fw-bold fs-15 text-primary"
                            style={{ color: "#1b74e4", fontStyle: "italic" }}
                          >
                            <ImageWithFallback
                              src={ProductInventorySVG}
                              alt="inventory"
                              height="15px"
                              width="15px"
                            />
                            &nbsp; Stocks left:{" "}
                            {(() => {
                              const filteredTypes =
                                productDetails?.inventoryInfo[0]?.quantityTypes.filter(
                                  (quantVal: any) =>
                                    quantVal?.forecastedDays !== null &&
                                    quantVal?.forecastedDays >= 0,
                                );

                              const hasType = (type: any) =>
                                filteredTypes.some(
                                  (quantVal: any) => quantVal.type === type,
                                );

                              const getTypeData = (type: any) =>
                                filteredTypes.find(
                                  (quantVal: any) => quantVal.type === type,
                                );

                              const result = [];
                              if (
                                hasType(CartonWithDozens) &&
                                hasType(Dozen) &&
                                hasType(Piece)
                              ) {
                                const cartonWithDozens =
                                  getTypeData(CartonWithDozens);
                                const dozen = getTypeData(Dozen);

                                if (cartonWithDozens?.forecastedDays > 0) {
                                  result.push(cartonWithDozens);
                                } else if (dozen?.forecastedDays > 0) {
                                  result.push(cartonWithDozens, dozen);
                                } else {
                                  result.push(
                                    cartonWithDozens,
                                    dozen,
                                    getTypeData(Piece),
                                  );
                                }
                              } else if (
                                hasType(CartonWithPieces) &&
                                hasType(Dozen) &&
                                hasType(Piece)
                              ) {
                                const cartonWithPieces =
                                  getTypeData(CartonWithPieces);
                                const dozen = getTypeData(Dozen);

                                result.push(cartonWithPieces, dozen);
                                if (
                                  dozen?.forecastedDays === 0 &&
                                  cartonWithPieces.forecastedDays === 0
                                ) {
                                  result.push(getTypeData(Piece));
                                }
                              } else if (
                                hasType(CartonWithPieces) &&
                                hasType(Piece)
                              ) {
                                const cartonWithPieces =
                                  getTypeData(CartonWithPieces);
                                if (cartonWithPieces?.forecastedDays > 0) {
                                  result.push(cartonWithPieces);
                                } else {
                                  result.push(
                                    cartonWithPieces,
                                    getTypeData(Piece),
                                  );
                                }
                              } else if (
                                hasType(CartonWithDozens) &&
                                hasType(Piece)
                              ) {
                                const cartonWithDozens =
                                  getTypeData(CartonWithDozens);
                                if (cartonWithDozens?.forecastedDays > 0) {
                                  result.push(cartonWithDozens);
                                } else {
                                  result.push(
                                    cartonWithDozens,
                                    getTypeData(Piece),
                                  );
                                }
                              } else if (
                                hasType(CartonWithPieces) &&
                                hasType(Dozen)
                              ) {
                                result.push(
                                  getTypeData(CartonWithPieces),
                                  getTypeData(Dozen),
                                );
                              } else if (
                                hasType(CartonWithDozens) &&
                                hasType(Dozen)
                              ) {
                                const cartonWithDozens =
                                  getTypeData(CartonWithDozens);
                                if (cartonWithDozens?.forecastedDays > 0) {
                                  result.push(cartonWithDozens);
                                } else {
                                  result.push(
                                    cartonWithDozens,
                                    getTypeData(Dozen),
                                  );
                                }
                              } else if (hasType(Dozen) && hasType(Piece)) {
                                const dozen = getTypeData(Dozen);
                                if (dozen?.forecastedDays > 0) {
                                  result.push(dozen);
                                } else {
                                  result.push(dozen, getTypeData(Piece));
                                }
                              } else if (hasType(Dozen)) {
                                result.push(getTypeData(Dozen));
                              } else if (hasType(Piece)) {
                                result.push(getTypeData(Piece));
                              } else if (hasType(CartonWithPieces)) {
                                result.push(getTypeData(CartonWithPieces));
                              } else if (hasType(CartonWithDozens)) {
                                result.push(getTypeData(CartonWithDozens));
                              }

                              return result.map((quantVal, index) => {
                                let typeText = "";
                                switch (quantVal.type) {
                                  case CartonWithDozens:
                                    typeText = "CWD";
                                    break;
                                  case Dozen:
                                    typeText = "DZN";
                                    break;
                                  case Piece:
                                    typeText = "PCS";
                                    break;
                                  case CartonWithPieces:
                                    typeText = "CWP";
                                    break;
                                  default:
                                    typeText = "";
                                }

                                return (
                                  <React.Fragment key={index}>
                                    {index !== 0 && ", "}
                                    <span>
                                      {typeText} ({quantVal.forecastedDays}{" "}
                                      {quantVal.forecastedDays === 1
                                        ? "day"
                                        : "days"}
                                      )
                                    </span>
                                  </React.Fragment>
                                );
                              });
                            })()}
                          </div>
                        </div>
                      </div>
                    ) : null}

                    <Card.Body className="pt-9 pb-0">
                      <div className="d-flex flex-wrap flex-sm-nowrap mb-3">
                        <div className="me-9 mb-4">
                          <div className="symbol symbol-150px symbol-lg-200px symbol-fixed border position-relative">
                            <div className="image-input d-flex flex-center rounded w-lg-200px h-lg-200px">
                              <div
                                className="image-input-wrapper shadow-none bgi-contain bgi-position-center w-100 h-100"
                                style={{
                                  backgroundImage: `url(${productDetails.media[0].url})`,
                                }}
                              ></div>
                            </div>
                          </div>
                        </div>
                        <div className="row align-items-center flex-grow-1">
                          <div className="d-flex justify-content-between align-items-start flex-wrap mb-2">
                            <div className="d-flex flex-column w-100">
                              <div className="d-flex flex-column mb-3">
                                <div className="d-flex align-items-center flex-wrap mb-2">
                                  <h3 className="text-black fs-22 fw-700 mb-0 me-5">
                                    {productDetails?.title?.replace(
                                      /\s*\)\s*/g,
                                      ")",
                                    )}
                                  </h3>
                                  <div className="d-flex align-items-center gap-2 my-1">
                                    {productDetails?.active[0]?.active ? (
                                      <span className="badge badge-light-success border-r4px px-3 py-2 fs-13 fw-bold text-success">
                                        Active Product
                                      </span>
                                    ) : (
                                      <span className="badge badge-light border-r4px px-3 py-2 fs-13 fw-bold text-gray-600">
                                        Deactivated Product
                                      </span>
                                    )}
                                    {productDetails?.inventoryInfo?.find(
                                      (x: any) =>
                                        x &&
                                        x.warehouseId ===
                                        selectedWarehouse?.value,
                                    )?.availableToSell ? (
                                      <span className="badge badge-light-primary border-r4px px-3 py-2 fs-13 fw-bold text-primary ">
                                        Available to Sell
                                      </span>
                                    ) : (
                                      <span className="badge badge-light-danger border-r4px px-3 py-2 fs-13 fw-bold text-danger">
                                        Not Available to Sell
                                      </span>
                                    )}
                                  </div>
                                </div>
                                <div className="d-flex align-items-center justify-content-between flex-wrap gap-4 mt-1">
                                  <span className="fs-16 fw-500 text-gray-500">
                                    Product ID:{" "}
                                    <span className="text-dark fw-bold">
                                      {productDetails.refKey}
                                    </span>
                                  </span>

                                  {Method.hasPermission(
                                    All_Products,
                                    Edit,
                                    currentUser,
                                  ) && (
                                      <div className="d-flex align-items-center gap-3 flex-wrap">
                                        <div className="d-flex align-items-center bg-light-warning rounded border border-warning border-dashed px-4 py-2">
                                          <label className="form-check form-switch form-check-custom form-check-solid">
                                            <input
                                              className="form-check-input form-check-success w-40px h-20px"
                                              type="checkbox"
                                              disabled={!selectedWarehouse?.value}
                                              checked={
                                                productDetails?.inventoryInfo?.find(
                                                  (x: any) =>
                                                    x &&
                                                    x.warehouseId ==
                                                    selectedWarehouse?.value,
                                                )?.availableToSell
                                              }
                                              onChange={() =>
                                                handleAvailableToSellToggle(
                                                  productDetails?.inventoryInfo?.find(
                                                    (x: any) =>
                                                      x &&
                                                      x.warehouseId ==
                                                      selectedWarehouse?.value,
                                                  )?.availableToSell,
                                                )
                                              }
                                            />
                                            <span className="fs-13 fw-bold text-warning ms-3">
                                              Available to Sell
                                            </span>
                                          </label>
                                        </div>
                                        <div className="d-flex align-items-center bg-light-warning rounded border border-warning border-dashed px-4 py-2">
                                          <label className="form-check form-switch form-check-custom form-check-solid">
                                            <input
                                              className="form-check-input form-check-success w-40px h-20px"
                                              type="checkbox"
                                              disabled={!selectedWarehouse?.value}
                                              checked={isPharmacyProduct}
                                              onChange={() =>
                                                handleIsPharmacyProductToggle(
                                                  isPharmacyProduct,
                                                )
                                              }
                                            />
                                            <span className="fs-13 fw-bold text-warning ms-3">
                                              Is Pharmacy Product
                                            </span>
                                          </label>
                                        </div>
                                      </div>
                                    )}
                                </div>
                              </div>
                              {productDetails?.status === PendingProduct ? (
                                <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                                  <div className="d-flex justify-content-center align-items-center bg-light-warning p-3 px-4 pills-radius">
                                    <span className="bullet bullet-dot bg-warning me-2 h-10px w-10px"></span>
                                    <span className="fw-600 text-black fs-18">
                                      Verification pending
                                    </span>
                                  </div>
                                </div>
                              ) : null}
                              {productDetails?.status === RejectedProduct ? (
                                <div className="d-flex flex-wrap fw-bold fs-6 mb-4 pe-2">
                                  <div className="d-flex justify-content-center align-items-center bg-light-danger p-3 px-4 pills-radius">
                                    <span className="bullet bullet-dot bg-danger me-2 h-10px w-10px"></span>
                                    <span className="fw-600 text-black fs-18">
                                      Product Rejected:{" "}
                                      {productDetails.statusMessage
                                        ? productDetails.statusMessage
                                        : "Your product details are invalid"}
                                    </span>
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <Col lg={12}>
                            <div className="d-flex flex-wrap flex-stack">
                              <div className="d-flex flex-column flex-grow-1 pe-8">
                                <div className="d-flex flex-wrap">
                                  <div className="bg-light border rounded min-w-125px py-3 px-4 me-6 mb-3">
                                    <div className="d-flex align-items-center">
                                      <div className="fs-22 fw-bold">
                                        {count}
                                      </div>
                                    </div>
                                    <div className="fw-500 fs-16">
                                      Orders in last month
                                    </div>
                                  </div>
                                  {productDetails?.inventoryInfo[0]
                                    ?.quantityTypes &&
                                    productDetails?.inventoryInfo[0]
                                      ?.quantityTypes.length
                                    ? productDetails.inventoryInfo[0].quantityTypes.map(
                                      (quantVal: any) => (
                                        <div
                                          className="bg-light border rounded min-w-125px py-3 px-4 me-6 mb-3"
                                          key={quantVal.type}
                                        >
                                          <div className="d-flex align-items-center">
                                            <div className="fs-2 fw-bolder">
                                              <OverlayTrigger
                                                trigger="hover"
                                                placement="bottom"
                                                overlay={remainingQuantity}
                                              >
                                                <span>
                                                  {quantVal.remainingQty}
                                                </span>
                                              </OverlayTrigger>{" "}
                                              +{" "}
                                              <OverlayTrigger
                                                trigger="hover"
                                                placement="bottom"
                                                overlay={reserveQuantity}
                                              >
                                                <span>
                                                  {quantVal.reservedQty}
                                                </span>
                                              </OverlayTrigger>{" "}
                                              ={" "}
                                              <OverlayTrigger
                                                trigger="hover"
                                                placement="bottom"
                                                overlay={totalQuantity}
                                              >
                                                <span>
                                                  {quantVal.stockCount}
                                                </span>
                                              </OverlayTrigger>{" "}
                                            </div>
                                          </div>
                                          <div className="fw-500 fs-16">
                                            {getQuantityTypeLabel(quantVal.type)}
                                            {" "}
                                            in stock
                                          </div>
                                        </div>
                                      ),
                                    )
                                    : null}
                                </div>
                              </div>
                            </div>
                          </Col>
                        </div>
                      </div>
                    </Card.Body>
                    <Row className="align-items-center px-lg-9 px-6">
                      <Col sm>
                        <div className="d-flex h-70px">
                          <ul className="nav nav-stretch nav-line-tabs nav-custom nav-tabs nav-line-tabs nav-line-tabs-2x border-transparent fs-18 fw-600">
                            {createTabs()}
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </Card>
                  <Col lg={12}>
                    <div className="tab-content" id="myTabContent">
                      <div className="tab-pane fade show active">
                        {renderTabContent()}
                      </div>
                    </div>
                  </Col>
                </>
              ) : null}
            </>
          )}
        </div>
      </div>
    </>
  );
};
export default ProductDetails;
